module.exports = __webpack_public_path__ + "img/linkedin.8913d14a.svg";